import React, { useState } from "react";

import embedConfig from "components/content-blocks/embed/config";

import EmbedBlocker from "components/content-blocks/embed/EmbedBlocker";

const EmbedBlockerContainer = ({ children }) => {
  const [consent] = useState(embedConfig.initConsent);

  return consent ? (
    children
  ) : (
    <EmbedBlocker onButtonClick={embedConfig.handleOnClick} />
  );
};

export default EmbedBlockerContainer;
